$(document).foundation();
$("[data-full-width]").each(function(){
    var $this = $(this);
    var stickToRight = $this.is("[data-stick-right]");
    if (!stickToRight) {
        $this.width($this.parent().width());
        $(window).resize(function () {
            $this.width($this.parent().width());
        });
    }
    else {
        $this.addClass("auto-max-width");
        var position = $this.parent().offset();
        var widthToUse = $(window).width() - position.left;
        $this.width(widthToUse);
        $(window).resize(function () {
            var position = $this.parent().offset();
            var widthToUse = $(window).width() - position.left;
            $this.width(widthToUse);
        });
    }
});
